document.addEventListener('DOMContentLoaded', function() {

  const arrows = document.querySelectorAll('.splide__arrows .splide__arrow');
  arrows.forEach(arrow => {
    const svg = arrow.querySelector('svg');
    if (svg) {
      svg.setAttribute('viewBox', '0 0 16 14');
      svg.style.width = '16px';
      svg.style.height = '14px';
    }
  });


  
  const header = document.querySelector('header.header');
  const imageBanner = document.querySelector('#MainContent>.shopify-section[id*="image_banner"]:first-child');
  
  if (!header || !imageBanner) return;
  
  header.classList.add('sticky-header-white');
  
  const triggerPoint = imageBanner.offsetHeight - 150;
  
  function handleScroll() {
    if (window.scrollY >= triggerPoint) {
      header.classList.remove('sticky-header-white');
    } else {
      header.classList.add('sticky-header-white');
    }
  }
  
  window.addEventListener('scroll', handleScroll);



  // Menu header
  const summaries = document.querySelectorAll('header-menu summary[link]');
  
  summaries.forEach(summary => {
    summary.addEventListener('click', function(e) {
      const clickedElement = e.target;
      const span = this.querySelector('span');
      
      // Si on clique sur le span ou un de ses enfants
      if (span && (clickedElement === span || span.contains(clickedElement))) {
        e.preventDefault();
        e.stopPropagation();
        
        const link = this.getAttribute('link');
        if (link) {
          window.location.href = link;
        }
      }
      // Sinon, comportement normal (ouverture du details)
    });
  });

  // Menu drawer
  const drawerSummaries = document.querySelectorAll('summary.menu-drawer__menu-item[link]');
  
  drawerSummaries.forEach(summary => {
    summary.addEventListener('click', function(e) {
      const clickedElement = e.target;
      const svgWrappers = this.querySelectorAll('.svg-wrapper');
      
      // Vérifier si on a cliqué sur un svg-wrapper ou son contenu
      let clickedOnSvg = false;
      svgWrappers.forEach(wrapper => {
        if (wrapper === clickedElement || wrapper.contains(clickedElement)) {
          clickedOnSvg = true;
        }
      });
      
      // Si on n'a PAS cliqué sur les svg, rediriger
      if (!clickedOnSvg) {
        e.preventDefault();
        e.stopPropagation();
        
        const link = this.getAttribute('link');
        if (link) {
          window.location.href = link;
        }
      }
      // Sinon, comportement normal (ouverture du details)
    });
  });
});